module.exports = __webpack_public_path__ + "static/media/filterLocation.6c8d6ebd.svg";